import React, {useState, useEffect} from "react";
import { GetCategoriesData, GetInputsData} from "../../../lib/data";
import AddCategoiresUi from "../../../ui/categoriesUi/AddCategoriesUi";
import i18n from "../../../lib/i18n";

export default function AddCategoires () {

    const [categoriesData, setCategoriesData] = useState([]);
    const [inputsData, setInputsData] = useState([]);
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const params = [ {"status": "main"} ];
        const categoryData = await GetCategoriesData(1, params);
        const inputsData = await GetInputsData();
        setCategoriesData([]);
        setInputsData([]);
        categoryData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        inputsData.data.map((e) => setInputsData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param},{"status": "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesData([]);
            categoriesDataFilter.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.category")}</h1>
                <AddCategoiresUi search={search} categoriesData={categoriesData} inputsData={inputsData} />
            </div>
        </div>
    );
};